export default __webpack_public_path__ + "static/media/medical-mask.df61e270.svg";